import React, {useEffect} from 'react';
//import {getColumnDefs} from './settings.js';

export default function ReviewValues({datagrid, gridRef, xlsWorkBook, settings}) {
  const gridApi = gridRef?.current?.api;

  const toggleColumnVisibility = () => {
    if (gridApi) {
      gridApi.setFilterModel([]);

      // let updatedColumnDefs = getColumnDefs(datagrid, settings, xlsWorkBook.ws_column_names);
      // gridApi.setGridOption('columnDefs', updatedColumnDefs)

      let updatedState = gridApi.getColumnState().map((colState) => {
        colState.hide = colState.colId.includes('-v') || colState.colId.includes('-e');
        return colState;
      });
      gridApi.applyColumnState({state: updatedState});
    }
  };

  useEffect(() => {
    toggleColumnVisibility();
    gridApi?.onFilterChanged()
  }, [settings]);

  return (<p>{I18n.t('excel_wizard_completion_notice')}</p>);
};
